import type { ThemeSchemaResponse } from '@api/api/theme-overview';
import { MonthlyCondensedSentiment } from '@terminal/components/monthly-condensed-sentiment/MonthlyCondensedSentiment';
import { usePulseSentimentBreakdown } from '@terminal/views/theme-overview/tab-content/pulse-overview/hooks/usePulseSentimentBreakdown';
import { usePulseMonthlySummaries } from '@terminal/views/theme-overview/tab-content/pulse-overview/hooks/usePulseSummaries';

export interface MonthlySentimentProps {
  theme: ThemeSchemaResponse;
}

export const MonthlySentiment = ({ theme }: MonthlySentimentProps) => {
  const monthlySummaries = usePulseMonthlySummaries({ id: theme.id });
  const sentimentBreakdown = usePulseSentimentBreakdown(theme);

  return (
    <MonthlyCondensedSentiment
      summaries={monthlySummaries.data}
      totals={sentimentBreakdown.data?.totals}
      isSummariesLoading={monthlySummaries.isLoading}
      isSentimentBreakdownLoading={sentimentBreakdown.isLoading}
    />
  );
};
